import { fetchEndpoint } from "../network";

/**
 * 24小时管理
 */

export default {
  /************************* 轮播图管理 **************************/
  carousel: {
    // 轮播图列表
    getList(params) {
      return fetchEndpoint("/contentCarousel/list", "GET", params);
    },
    // 添加
    add(data) {
      return fetchEndpoint("/contentCarousel/insert", "POST", data);
    },
    // 编辑
    edit(data) {
      return fetchEndpoint("/contentCarousel/update", "POST", data);
    },
    //批量操作
    batch(params) {
      return fetchEndpoint("/contentCarousel/updateBatch", "GET", params);
    },
  },
  /************************* 媒体号管理 **************************/
  media: {
    // 媒体号列表
    getList(params) {
      return fetchEndpoint("/relation/mediaList", "GET", params);
    },
    // 备选媒体号列表
    getAllList(params) {
      return fetchEndpoint("/mediaAccount/selectMediaList", "GET", params);
    },
    // 添加
    add(data) {
      return fetchEndpoint("/relation/insertBatch", "POST", data);
    },
    //批量操作
    del(params) {
      return fetchEndpoint("/relation/delectBatch", "GET", params);
    },
    //批量操作
    batch(params) {
      return fetchEndpoint("/relation/updateBatch", "POST", params);
    },
  },
  /************************* 圈子管理 **************************/
  circle: {
    // 圈子列表
    getList(params) {
      return fetchEndpoint("/relation/circleList", "GET", params);
    },
    // 备选圈子列表
    getAllList(params) {
      return fetchEndpoint("/circle/selectCircleList", "GET", params);
    },
    // 添加
    add(data) {
      return fetchEndpoint("/relation/insertBatch", "POST", data);
    },
    //批量操作
    del(params) {
      return fetchEndpoint("/relation/delectBatch", "GET", params);
    },
  },
  /************************* 信息流管理 **************************/
  information: {
    // 信息流列表
    getList(params) {
      return fetchEndpoint("/mediaAccount/mediaContent", "GET", params);
    },
    // 置顶列表
    getTopList(params) {
      return fetchEndpoint("/relation/mediaContentList", "GET", params);
    },
    //置顶
    addTop(params) {
      return fetchEndpoint("/relation/insertBatch", "POST", params);
    },
    //取消置顶
    cancelTop(params) {
      return fetchEndpoint("/relation/delectBatch", "GET", params);
    },
    //置顶排序
    changeSort(params) {
      return fetchEndpoint("/relation/updateBatch", "POST", params);
    },
    //媒体号添加
    insertBatch(params) {
      return fetchEndpoint("/relation/insertBatch", "POST", params);
    },
    //选择媒体号列表
    selectMediaList(params) {
      return fetchEndpoint("/mediaAccount/selectMediaList", "GET", params);
    },
    //信息流绑定的媒体号
    bindIngMedia(params) {
      return fetchEndpoint("/relation/bindingMedia", "GET", params);
    },
  },
};
